<template>
  <div>
    <full-page :options="options" id="fullpage" ref="fullpage">
      <header-page :displayLogo="false"></header-page>
      <div class="section " id="section0">
        <video id="myVideo" loop muted data-autoplay>
          <source src="/videos/traiteur-croustillance.mp4" type="video/mp4">
          <source src="/videos/traiteur-croustillance.webm" type="video/webm">
        </video>
        <div class="layer">
          <img src="/img/logo-croustillance.svg" class="image-home"><br>
        </div>
        <div class="goDown">
          <v-icon size="60" color="#2c6730"
                  @click="$vuetify.goTo('#welcome',{ duration:1000, offset:0, easing:'easeInOutCubic'})">
            mdi-chevron-down
          </v-icon>
        </div>
      </div>
    </full-page>
    <div class="content" id="welcome">
      <div class="media-row">
        <div class="row backgroundGreen">
          <crousti-news :itemsNumber="1" :newsData="$store.state.news">
          </crousti-news>
        </div>
      </div>
      <div class="media-row flex-height">
        <div class="row  backgroundGreen">
          <div class="col-12 center-v">
            <div class="media item anim fullwidth">
              <div class="media-img">
                <div class="mask bg-primary"></div>
              </div>
              <div class="media-body">
                <article class="article-page margin-tb width-article text-center">
                  <div class="article-header sr-up-td1">
                    <h1 class=" display-title text-white h1Accueil">Traiteur &amp; créateur de
                      saveurs<br>dans les Vosges</h1>
                  </div>
                  <!-- title and description -->
                  <div class="article-content sr-up-td2 text-white">
                    <p class="AccueilP">
                      Le traiteur Croustillance accompagne depuis bientôt 10 ans tous vos événements,
                      privés et
                      professionnels.
                      Notre cuisine, savoureuse et authentique, est à notre image : les deux pieds
                      bien
                      ancrés dans le terroir vosgien, et le regard pétillant tourné vers le reste
                      du monde.</p>
                    <p class="AccueilP"> Chez Croustillance, seul et unique
                      <router-link :to="{ name: 'vosgesTerroir'}"
                                   class="LinkText">traiteur labellisé Vosges Terroir
                      </router-link>
                      , nous
                      sommes de
                      fervents défenseurs du manger local, frais et de saison. Nous travaillons
                      des produits
                      de qualité, dans le respect des techniques artisanales.
                    </p>
                    <p class="AccueilP"> Mais nous aimons aussi les défis un peu fous, les saveurs
                      insolites et la
                      cuisine
                      fusion. Pour réussir tous vos mariages, cocktails, buffets et animations,
                      vous
                      pouvez faire
                      confiance à Croustillance, le créateur de vos folies culinaires !</p>
                    <p class="AccueilP"> Nous assurons régulièrement des prestations à Charmes,
                      Épinal,
                      Rambervillers,
                      Saint-Dié, Vittel, Gérardmer… et nous nous déplaçons partout ailleurs en
                      Lorraine.</p>
                  </div>
                  <!-- Action button -->
                  <div class="btns-action sr-up-td3 text-primary">
                    <router-link :to="{ name: 'contact' }" class="btn btn-normal btn-white">
                      <span class="text">Parlez-nous de vos projets</span>
                      <span class="icon">
                            <span class="arrow-right"></span>
                          </span>
                    </router-link>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="media-row">
        <div class="row backgroundGreen">
          <div class="col-12 col-md-4 col-lg-4"
               style="background-image: url('img/accueil/reception-privee.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
            <div class="item media text-white alignLeft">
              <div class="media-body align-top">
                <div class="desc">
                  <h3 class="display-6">Réceptions privées</h3>
                  <p class="pSpacer" style="background-color: #95c01e80">
                    Pour vos fêtes et banquets, en famille ou entre amis, Croustillance vous propose
                    un large choix de menus pour faire pétiller les papilles de vos invités.
                  </p>
                  <p class="pSpacer" style="background-color: #95c01e80">Mariages, anniversaires, départs en retraite,
                    baptêmes, etc. : découvrez nos
                    suggestions de cocktails, buffets et menus chauds pour en garder un souvenir
                    inoubliable !

                  </p>
                  <div class="btns-action sr-up-td3 text-primary">
                    <router-link :to="{ name: 'cocktailPar' }"
                                 class="btn btn-normal btn-white spaceTop">
                      <span class="text">Notre offre pour vos cocktails</span>
                      <span class="icon">
                            <span class="arrow-right"></span>
                          </span>
                    </router-link>
                  </div>
                  <div class="btns-action sr-up-td3 text-primary">
                    <router-link :to="{ name: 'buffetPar' }"
                                 class="btn btn-normal btn-white spaceTop">
                      <span class="text">Nos propositions de buffets</span>
                      <span class="icon">
                            <span class="arrow-right"></span>
                          </span>
                    </router-link>
                  </div>
                  <div class="btns-action sr-up-td3 text-primary">
                    <router-link :to="{ name: 'repasPar' }"
                                 class="btn btn-normal btn-white spaceTop">
                      <span class="text">Les menus chauds</span>
                      <span class="icon">
                            <span class="arrow-right"></span>
                          </span>
                    </router-link>
                  </div>
                  <div class="btns-action sr-up-td3 text-primary">
                    <router-link :to="{ name: 'mariage' }"
                                 class="btn btn-normal btn-white spaceTop">
                      <span class="text">Notre carte spéciale mariages</span>
                      <span class="icon">
                            <span class="arrow-right"></span>
                          </span>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4 col-lg-4" style="background:#b3a3a4;">
            <div class="item media text-white alignLeft">
              <div class="media-img">
              </div>
              <div class="media-body align-top">
                <div class="desc">
                  <h3 class="display-6">Événements professionnels</h3>
                  <p>
                    Croustillance a développé des offres spécifiques pour toutes les pauses
                    gourmandes et les repas qui comptent dans la vie de votre entreprise. Pensées
                    pour les professionnels, les associations et les collectivités locales, ces
                    prestations sur mesure s’ajustent à toutes les configurations, jusqu’à 750
                    couverts.
                  </p>
                  <div class="btns-action sr-up-td3 text-primary">
                    <router-link :to="{ name: 'plateau' }"
                                 class="btn btn-normal btn-white spaceTop">
                      <span class="text">Nos plateaux-repas</span>
                      <span class="icon">
                            <span class="arrow-right"></span>
                          </span>
                    </router-link>
                  </div>
                  <div class="btns-action sr-up-td3 text-primary">
                    <router-link :to="{ name: 'cocktailPro' }"
                                 class="btn btn-normal btn-white spaceTop">
                      <span class="text">Nos propositions de cocktails</span>
                      <span class="icon">
                            <span class="arrow-right"></span>
                          </span>
                    </router-link>
                  </div>
                  <div class="btns-action sr-up-td3 text-primary">
                    <router-link :to="{ name: 'repasPro' }"
                                 class="btn btn-normal btn-white spaceTop">
                      <span class="text">Les menus chauds pour les pros</span>
                      <span class="icon">
                            <span class="arrow-right"></span>
                          </span>
                    </router-link>
                  </div>
                  <div class="btns-action sr-up-td3 text-primary">
                    <router-link :to="{ name: 'buffetPro' }"
                                 class="btn btn-normal btn-white spaceTop">
                      <span class="text">La carte des buffets</span>
                      <span class="icon">
                            <span class="arrow-right"></span>
                          </span>
                    </router-link>
                  </div>
                  <div class="btns-action sr-up-td3 text-primary">
                    <router-link :to="{ name: 'evenements' }"
                                 class="btn btn-normal btn-white spaceTop">
                      <span class="text">Les animations culinaires</span>
                      <span class="icon">
                            <span class="arrow-right"></span>
                          </span>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4 col-lg-4"
               style="background-image: url('img/accueil/location-materiel.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
            <div class="item media text-white alignLeft">
              <div class="media-img">
                <div class="mask"></div>
                <img class="img-block" src="img/accueil/location-materiel.jpg" alt="Location de matériel traiteur"
                     style="display: none;">
                <div class="img"
                     style="background-image: url('img/accueil/location-materiel.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
              </div>
              <div class="media-body align-top">
                <div class="desc">
                  <h3 class="display-6">Location de matériel traiteur </h3>
                  <p class="pSpacer" style="background-color: #73637d91">
                    Croustillance, c’est aussi un service de location d’appareils et de matériel
                    professionnel, pour faciliter l’organisation de tous vos événements.</p>
                  <p class="pSpacer" style="background-color: #73637d91">
                    Dressage, mobilier, véhicules frigorifiques, rôtissoire, planchas, machines à
                    pop-corn, etc. : notre offre s’adapte à vos besoins, avec ou sans serveurs.
                  </p>
                  <div class="btns-action sr-up-td3 text-primary">
                    <router-link :to="{ name: 'location' }"
                                 class="btn btn-normal btn-white spaceTop">
                      <span class="text">Notre matériel traiteur à louer</span>
                      <span class="icon">
                            <span class="arrow-right"></span>
                          </span>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="media-row">
      <div class="row backgroundGreen">
        <div class="col-12 col-md-4 col-lg-4" style="background:#eb4f78;">
          <div class="item media text-white alignLeft">
            <div class="media-body align-top">
              <div class="desc">
                <h3 class="display-6">Vous habitez à proximité de Charmes ou de Châtel/Nomexy ?</h3>
                <p>
                  Croustillance vous propose un service de portage de repas à domicile, sans
                  abonnement.
                  Nos menus, élaborés sous le contrôle d’un diététicien, sont goûteux, variés et
                  équilibrés. </p>
                <p>
                  <router-link :to="{ name: 'equipe'}"
                               class="LinkText">Deux membres de notre équipe
                  </router-link>
                  sont spécialement dédiés à cette mission. Chaque jour,
                  les repas commandés vous sont livrés à bord d’un véhicule frigorifique, pour une
                  hygiène parfaite. Et pour que votre plaisir soit complet, tous nos petits plats sont
                  servis dans de la vaisselle en porcelaine !
                </p>
                <div class="btns-action sr-up-td3 text-primary">
                  <router-link :to="{ name: 'portage' }"
                               class="btn btn-normal btn-white spaceTop">
                    <span class="text">Notre service de repas à domicile</span>
                    <span class="icon">
                            <span class="arrow-right"></span>
                          </span>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4 col-lg-4"
             style="background-image: url('img/accueil/verrine-cocktail.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
          <div class="item media text-white alignLeft">
            <div class="media-img">
              <div class="mask"></div>
              <img class="img-block" src="img/accueil/verrine-cocktail.jpg" alt="Le traiteur qui vous régale !"
                   style="display: none;">
              <div class="img"
                   style="background-image: url('img/accueil/verrine-cocktail.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
            </div>
            <div class="media-body align-top">
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4 col-lg-4" style="background:#95c01e;">

          <div class="desc">
            <div class="contactBackground">
              <div class="container-c" style="margin-top:20px;">
                <div><img src="/img/logo-croustillance-blanc.svg" width="350px;"
                          alt="Croustillance, traiteur dans les Vosges et départements de lorraine">
                  <br/><br/> 10 rue de l'Estrey<br/>88440 Nomexy
                  <hr color="white">
                  <v-icon color="white" size="25" style="margin-top:-5px;">mdi-phone</v-icon>
                  <a href="tel:0684264563"><span class="whitetext"> 06 84 26 45 63</span></a>
                  <hr color="white">
                  <v-icon color="white" size="25" style="margin-top:-5px;">mdi-email</v-icon>
                  <a href="mailto:info@croustillance.fr"><span class="whitetext"> info@croustillance.fr</span></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer-page></footer-page>
  </div>
</template>

<script>
import * as easings from 'vuetify/es5/services/goto/easing-patterns'
import FooterPage from './footerPage'
import CroustiNews from "./croustiNews"
import HeaderPage from './headerPage'

export default {
  name: "accueil",
  components: {
    FooterPage,
    CroustiNews,
    HeaderPage

  },
  data() {
    return {
      options: {
        licenseKey: 'A32C7F42-F0FE4A04-AAB7E182-AB1F9C8B',
        navigation: false,
        scrollBar: true,
        autoScrolling: false,
        fitToSection: false

      },
      easings: Object.keys(easings)
    };
  },
  created() {
    document.getElementsByTagName('meta')["description"].content = "Croustillance, traiteur dans les Vosges, accompagne tous vos événements : mariages, cocktails, buffets, menus chauds, plateaux-repas et animations culinaires.";
    document.title = "Croustillance, traiteur et créateur de saveurs dans les Vosges";
  }
}
</script>

<style>
.LinkText {
  text-decoration: underline;
}

.AccueilP {
  text-align: left;
  padding-bottom: 15px;
}

.alignLeft {
  text-align: left;
}

.h1Accueil {
  font-family: 'Montserrat', sans-serif;
  font-size: 50px;
}

.goDown {
  position: absolute;
  bottom: 0;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  z-index: 10;
  background: #ffffff7a;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.titreAccueil {
  color: #2c6730;
  font-family: 'Nunito', sans-serif;
  font-size: 25px;
}

.backgroundGreen {
  background: #95c01e;
  margin-right: 0px !important;
  margin-left: 0px !important;

}

.section {
  text-align: center;
  overflow: hidden;
}

#myVideo {
  position: absolute;
  right: 0;
  bottom: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  background-color: #95c01e; /* in case the video doesn't fit the whole page*/
  background-image: /* our video */;
  background-position: center center;
  background-size: contain;
  object-fit: cover; /*cover video background */
  z-index: 3;
}

/* Layer with position absolute in order to have it over the video
* --------------------------------------- */
#section0 .layer {
  position: absolute;
  z-index: 4;
  width: 100%;
  left: 0;
  transform: translateY(-50%);
  /*
  * Preventing flicker on some browsers
  * See http://stackoverflow.com/a/36671466/1081396  or issue #183
  */
  background-color: #ffffff7a;
  padding-top: 20px;
  padding-bottom: 10px;
}

/*solves problem with overflowing video in Mac with Chrome */
#section0 {
  overflow: hidden;
}

/* Bottom menu
* --------------------------------------- */
#infoMenu li a {
  color: #fff;
}

/* Hiding video controls
* See: https://css-tricks.com/custom-controls-in-html5-video-full-screen/
* --------------------------------------- */
video::-webkit-media-controls {
  display: none !important;
}

.image-home {
  width: 100%;
  max-width: 400px;
}

/*!
* fullPage 3.0.7
* https://github.com/alvarotrigo/fullPage.js
*
* @license GPLv3 for open source use only
* or Fullpage Commercial License for commercial use
* http://alvarotrigo.com/fullPage/pricing/
*
* Copyright (C) 2018 http://alvarotrigo.com/fullPage - A project by Alvaro Trigo
*/
html.fp-enabled,
.fp-enabled body {
  margin: 0;
  padding: 0;
  overflow: hidden;

  /*Avoid flicker on slides transitions for mobile phones #336 */
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.fp-section {
  position: relative;
  -webkit-box-sizing: border-box; /* Safari<=5 Android<=3 */
  -moz-box-sizing: border-box; /* <=28 */
  box-sizing: border-box;
}

.fp-slide {
  float: left;
}

.fp-slide, .fp-slidesContainer {
  height: 100%;
  display: block;
}

.fp-slides {
  z-index: 1;
  height: 100%;
  overflow: hidden;
  position: relative;
  -webkit-transition: all 0.3s ease-out; /* Safari<=6 Android<=4.3 */
  transition: all 0.3s ease-out;
}

.fp-section.fp-table, .fp-slide.fp-table {
  display: table;
  table-layout: fixed;
  width: 100%;
}

.fp-tableCell {
  display: table-cell;
  vertical-align: middle;
  width: 100%;
  height: 100%;
}

.fp-slidesContainer {
  float: left;
  position: relative;
}

.fp-controlArrow {
  -webkit-user-select: none; /* webkit (safari, chrome) browsers */
  -moz-user-select: none; /* mozilla browsers */
  -khtml-user-select: none; /* webkit (konqueror) browsers */
  -ms-user-select: none; /* IE10+ */
  position: absolute;
  z-index: 4;
  top: 50%;
  cursor: pointer;
  width: 0;
  height: 0;
  border-style: solid;
  margin-top: -38px;
  -webkit-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

.fp-controlArrow.fp-prev {
  left: 15px;
  width: 0;
  border-width: 20px 30px 20px 0;
  border-color: transparent white transparent transparent;
}

.fp-controlArrow.fp-next {
  right: 15px;
  border-width: 20px 0 20px 30px;
  border-color: transparent transparent transparent white;
}

.fp-scrollable {
  overflow: hidden;
  position: relative;
}

.fp-scroller {
  overflow: hidden;
}

.iScrollIndicator {
  border: 0 !important;
}

.fp-notransition {
  -webkit-transition: none !important;
  transition: none !important;
}

#fp-nav {
  position: fixed;
  z-index: 100;
  margin-top: -32px;
  top: 50%;
  opacity: 1;
  -webkit-transform: translate3d(0, 0, 0);
}

#fp-nav.fp-right {
  right: 17px;
}

#fp-nav.fp-left {
  left: 17px;
}

.fp-slidesNav {
  position: absolute;
  z-index: 4;
  opacity: 1;
  -webkit-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  left: 0 !important;
  right: 0;
  margin: 0 auto !important;
}

.fp-slidesNav.fp-bottom {
  bottom: 17px;
}

.fp-slidesNav.fp-top {
  top: 17px;
}

#fp-nav ul,
.fp-slidesNav ul {
  margin: 0;
  padding: 0;
}

#fp-nav ul li,
.fp-slidesNav ul li {
  display: block;
  width: 14px;
  height: 13px;
  margin: 7px;
  position: relative;
}

.fp-slidesNav ul li {
  display: inline-block;
}

#fp-nav ul li a,
.fp-slidesNav ul li a {
  display: block;
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  cursor: pointer;
  text-decoration: none;
}

#fp-nav ul li a.active span,
.fp-slidesNav ul li a.active span,
#fp-nav ul li:hover a.active span,
.fp-slidesNav ul li:hover a.active span {
  height: 12px;
  width: 12px;
  margin: -6px 0 0 -6px;
  border-radius: 100%;
}

#fp-nav ul li a span,
.fp-slidesNav ul li a span {
  border-radius: 50%;
  position: absolute;
  z-index: 1;
  height: 4px;
  width: 4px;
  border: 0;
  background: #333;
  left: 50%;
  top: 50%;
  margin: -2px 0 0 -2px;
  -webkit-transition: all 0.1s ease-in-out;
  -moz-transition: all 0.1s ease-in-out;
  -o-transition: all 0.1s ease-in-out;
  transition: all 0.1s ease-in-out;
}

#fp-nav ul li:hover a span,
.fp-slidesNav ul li:hover a span {
  width: 10px;
  height: 10px;
  margin: -5px 0px 0px -5px;
}

#fp-nav ul li .fp-tooltip {
  position: absolute;
  top: -2px;
  color: #fff;
  font-size: 14px;
  font-family: arial, helvetica, sans-serif;
  white-space: nowrap;
  max-width: 220px;
  overflow: hidden;
  display: block;
  opacity: 0;
  width: 0;
  cursor: pointer;
}

#fp-nav ul li:hover .fp-tooltip,
#fp-nav.fp-show-active a.active + .fp-tooltip {
  -webkit-transition: opacity 0.2s ease-in;
  transition: opacity 0.2s ease-in;
  width: auto;
  opacity: 1;
}

#fp-nav ul li .fp-tooltip.fp-right {
  right: 20px;
}

#fp-nav ul li .fp-tooltip.fp-left {
  left: 20px;
}

.fp-auto-height.fp-section,
.fp-auto-height .fp-slide,
.fp-auto-height .fp-tableCell {
  height: auto !important;
}

.fp-responsive .fp-auto-height-responsive.fp-section,
.fp-responsive .fp-auto-height-responsive .fp-slide,
.fp-responsive .fp-auto-height-responsive .fp-tableCell {
  height: auto !important;
}

/*Only display content to screen readers*/
.fp-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.pSpacer {
  padding: 0px 10px;
}
</style>